import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import LoadingDots from '../components/LoadingDots';

import ListingStep1 from '../components/ListingStep1';
import ListingStep2 from '../components/ListingStep2';
import ListingStep3 from '../components/ListingStep3';
import ListingStep4 from '../components/ListingStep4';
import ListingStep5 from '../components/ListingStep5';
import ListingStep6 from '../components/ListingStep6';
import ListingStep7 from '../components/ListingStep7';
import ListingStep8 from '../components/ListingStep8';
import ListingStep9 from '../components/ListingStep9';
import ListingStep10 from '../components/ListingStep10';
import ListingStep11 from '../components/ListingStep11';
import ListingStep12 from '../components/ListingStep12';
import ListingStep13 from '../components/ListingStep13';
import ListingStep14 from '../components/ListingStep14';
import ListingStep15 from '../components/ListingStep15';
import ListingStep16 from '../components/ListingStep16';
import ListingStep17 from '../components/ListingStep17';
import ListingStep18 from '../components/ListingStep18';
import ListingStep19 from '../components/ListingStep19';
import ListingStep20 from '../components/ListingStep20';

const CreateListing = () => {
  const [step, setStep] = useState(1);
  const { listingId } = useParams();
  const totalSteps = 20;
  const [formData, setFormData] = useState({
    listingId: listingId || null,
  });
  const [nextLoading, setNextLoading] = useState(false);
  const [currentStepSaveFunction, setCurrentStepSaveFunction] = useState(null);
  const [hitSubmit,setHitSubmit] = useState(false)

  const handleNextStep = async () => {
    setNextLoading(true);
    document?.getElementById(`host-listing-trigger-${step}`)?.click()
    setHitSubmit(true)
  };

  useEffect(() => {

    async function hitSaveFn() {
      if (currentStepSaveFunction) {
        try {
          const success = await currentStepSaveFunction();
          if (success) {
            await new Promise(resolve => setTimeout(resolve, 2000));
            setStep(prevStep => prevStep + 1);
            setHitSubmit(false)
            setNextLoading(false);
          }else{
            setHitSubmit(false)
            setNextLoading(false);
          }
        } catch (error) {
          console.error("Error during step save:", error);
          setHitSubmit(false)
          setNextLoading(false);
        }
      } else {
        setStep(prevStep => prevStep + 1);
        setHitSubmit(false)
        setNextLoading(false);
      }
    }

    if (hitSubmit){
      hitSaveFn()
    }
  }, [hitSubmit])



  const handlePrevStep = () => setStep(prevStep => prevStep - 1);

  const handleChange = (input) => (value) => {
    setFormData(prevData => ({ ...prevData, [input]: value }));
  };

  const progressPercentage = (step / totalSteps) * 100;

  useEffect(() => {
    console.log('Current step:', step);
    console.log('Form data:', formData);
  }, [step, formData]);

  const ProgressBar = () => (
    <div className='progress-bar'>
      <div style={{ width: '100%', backgroundColor: '#e0e0e0' }}>
        <div
          style={{
            width: `${progressPercentage}%`,
            backgroundColor: '#000',
            height: '10px',
            transition: 'width 0.3s ease-in-out',
          }}
        />
      </div>
    </div>
  );

  const renderStep = () => {

    const stepProps = {
      onRegisterSave: (saveFn) => {
        console.log(`CreateListing: Registering save function for step ${step}.`);
        setCurrentStepSaveFunction(() => saveFn);
      },
      handleChange: handleChange,
      formData: formData,
      setFormData: setFormData,
      prevStep: handlePrevStep,
    };

    switch (step) {
      case 1:
        return <ListingStep1 {...stepProps} />;
      case 2:
        return <ListingStep2 {...stepProps} />;
      case 3:
        return <ListingStep3 {...stepProps} />;
      case 4:
        return <ListingStep4 {...stepProps} />;
      case 5:
        return <ListingStep5 {...stepProps} />;
      case 6:
        return <ListingStep6 {...stepProps} />;
      case 7:
        return <ListingStep7 {...stepProps} />;
      case 8:
        return <ListingStep8 {...stepProps} />;
      case 9:
        return <ListingStep9 {...stepProps} />;
      case 10:
        return <ListingStep10 {...stepProps} />;
      case 11:
        return <ListingStep11 {...stepProps} />;
      case 12:
        return <ListingStep12 {...stepProps} />;
      case 13:
        return <ListingStep13 {...stepProps} />;
      case 14:
        return <ListingStep14 {...stepProps} />;
      case 15:
        return <ListingStep15 {...stepProps} />;
      case 16:
        return <ListingStep16 {...stepProps} />;
      case 17:
        return <ListingStep17 {...stepProps} />;
      case 18:
        return <ListingStep18 {...stepProps} />;
      case 19:
        return <ListingStep19 {...stepProps} />;
      case 20:
        return <ListingStep20 {...stepProps} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Helmet>
        <title>Create Listing</title>
        <meta name="description" content="" />
      </Helmet>

      <ProgressBar />

      <SwitchTransition mode="out-in">
        <CSSTransition
          key={step}
          timeout={400}
          classNames="fade-step"
          unmountOnExit
        >
          <div className="step-container">
            {renderStep()}
          </div>
        </CSSTransition>
      </SwitchTransition>

      <div className='clp-footer'>
        <button
          className='btn btn-blank'
          onClick={handlePrevStep}
          disabled={step === 1}
        >
          Back
        </button>
        <button
          className='btn btn-black'
          onClick={handleNextStep}
          disabled={nextLoading}
        >
          {nextLoading ? (
            <LoadingDots />
          ) : (
            step === totalSteps ? 'Save' : 'Next'
          )}
        </button>
      </div>

    </div>
  );

};

export default CreateListing;
